module.exports = __webpack_public_path__ + "static/media/thumbnail.80ea0e7a.jpg";